var TEMPLATE_URL = require('./loader.html');

angular.module('ikeweb.spike')
    .directive('loader', function() {
        return {
            restrict: 'E',
            replace: true,
            templateUrl: TEMPLATE_URL,
            scope: true,
            link: function($scope, $element, $attrs) {}
        };
    });



//////////////////
// WEBPACK FOOTER
// ./src/client/components/spike/loader/loader.directive.js
// module id = 580
// module chunks = 0